import { action, makeAutoObservable, observable } from 'mobx';
import { PlayingGameMode } from '../../enums/PlayingGameMode';

class ConfigStore {
  partnerId = 4;

  currencyCode = 'FUN';

  currencySymbol = null;

  demoBonusId = null;

  rate = 1;

  maxWinLimit = 100000;

  precision = 2;

  mode = PlayingGameMode.Demo;

  language = 'en';

  constructor() {
    makeAutoObservable(this, {
      partnerId: observable.struct,
      currencyCode: observable.struct,
      currencySymbol: observable.struct,
      rate: observable.struct,
      maxWinLimit: observable.struct,
      precision: observable.struct,
      demoBonusId: observable.struct,
      language: observable.struct,
      mode: observable.struct,
      resultHash: observable.struct,
      setPartnerId: action.bound,
      setCurrencyCode: action.bound,
      setDemoBonusId: action.bound,
      setMode: action.bound,
      setLanguage: action.bound,
      setResultHash: action.bound,
    });
  }

  setPartnerId(id) {
    this.partnerId = id;
  }

  setRate(rate) {
    this.rate = rate;
  }

  setMaxWinLimit(maxWinLimit) {
    this.maxWinLimit = maxWinLimit;
  }

  setPrecision(precision) {
    this.precision = precision;
  }

  setLanguage(lan) {
    this.language = lan;
  }

  setCurrencyCode(code) {
    this.currencyCode = code;
  }

  setCurrencySymbol(symbol) {
    this.currencySymbol = symbol;
  }

  setDemoBonusId(bonusId) {
    this.demoBonusId = bonusId;
  }

  setMode(mode) {
    this.mode = mode;
  }

  setResultHash(hash) {
    this.resultHash = hash;
  }
}

export const configStore = new ConfigStore();
